import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AutoFocusDirective } from '@app/@core/directives/auto-focus.directive';
import { BlockcutcopypasteDirective } from '@app/@core/directives/blockcutcopypaste.directive';
import { AuthService } from '@app/@core/services/auth.service';
import { AppRoutingModule } from '@app/app-routing.module';
import { AppComponent } from '@app/app.component';
import { PagesComponent } from '@app/pages/pages.component';
import { SwitchRoleComponent } from '@app/pages/switch-role/switch-role.component';
import { HelpDeskModule } from '@app/pages/pics-lib/help-desk/help-desk.module';
import { ChatbotRasaModule } from '@app/shared/features/chatbot/lib/chatbot-rasa.module';
import { PrimengModule } from '@app/shared/modules/primeng.module';
import { SharedModule } from '@app/shared/shared.module';
import { ChangePasswordModule } from '@core/auth/change-password/change-password.module';
import { LoginModule } from '@core/auth/login/login.module';
import { CoreModule } from '@core/core.module';
import { DirectivesModule } from '@core/directives/directives.module';
import { HttpService } from '@core/services/http.service';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { LoginNoCaptchaModule } from './@core/auth/login-no-captcha/login-no-captcha.module';
import { MaterialUIModule } from './shared/modules/material-ui/material-ui.module';
import { providePrimeNG } from 'primeng/config';
import Lara from '@primeng/themes/lara';
import { GlobalErrorHandler } from './global-error-handler';
import { TooltipModule } from 'primeng/tooltip';
import { AuthOidcModule } from './@core/auth/auth-oidc.module';
import { SsoCallbackModule } from './@core/auth/sso-callback/sso-callback.module';
import { PublicHelpComponent } from './@core/auth/public-help/public-help.component';
import { TokenExpiredComponent } from './pages/verification-link-expired/verification-link-expired';

@NgModule({
    declarations: [AppComponent, PagesComponent, SwitchRoleComponent, AutoFocusDirective, BlockcutcopypasteDirective, PublicHelpComponent, TokenExpiredComponent],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [BrowserModule,
        AppRoutingModule,
        SharedModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        LoginModule,
        LoginNoCaptchaModule,
        ChangePasswordModule,
        PrimengModule,
        CoreModule,
        DirectivesModule,
        ChatbotRasaModule,
        HelpDeskModule,
        MatSnackBarModule,
        NgIdleKeepaliveModule.forRoot(),
        TooltipModule,
        AuthOidcModule,
        SsoCallbackModule,

        MaterialUIModule],
    providers: [
        HttpService, AuthService, provideHttpClient(withInterceptorsFromDi()),
        providePrimeNG({
            theme: {
                preset: Lara,
                options: {
                    prefix: 'p',
                    darkModeSelector: false, // Disable automatic dark mode detection
                },
            }
        }),
        { provide: ErrorHandler, useClass: GlobalErrorHandler }
    ],
})
export class AppModule { }